import React from 'react';
import { Link } from 'react-router-dom';

const CommonLink = ({ link, title, icon }) => {
  return (
    <li className="nav-item">
      <Link to={link} className="nav-link" title={title}>
        <i className={`wb webconnect-${icon}`}></i>
      </Link>
    </li>
  );
};

export default CommonLink;
